import React from 'react'
import {Field, change as changeFieldValue, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import {renderTextArea, required} from '../../util/inputs'
import { showErrorMsg, showSuccessMsg } from '../../util/messagesUtil';
import { tamanhoArquivoUpload } from '../../util/applicationContext';
import cancelarReservasComReembolso from '../../actions/reserva/cancelarReservasComReembolso';

export class ModalConfirmacaoReservasParaReembolsoEfetivado extends React.Component {
  fecharModal () {
    $('#modalConfirmacaoReservasParaReembolsoEfetivado').modal('hide');
    $('#modalConfirmacaoReservasParaReembolsoEfetivado').hide();
    $('.modal-backdrop').hide();
    this.removerArquivo();
  }

  montarParametros(values) {
    return {
      empresaId: this.props.empresaSelecionada.id,
      motivo: values.observacao,
      habilitadoZerarValorMultaCancelamento: false,
      reservas: this.props.reservas.filter(f => f.selecionada).map(it => it.id),
      base64ComprovanteReembolso: this.props.base64ComprovanteReembolso,
      nomeComprovanteReembolso: this.props.nomeComprovanteReembolso
    }
  }

  submit (values) {
    this.props.cancelarReservasComReembolso(this.montarParametros(values))
      .then(() => {
          showSuccessMsg('Cancelado Com Reembolso');
          this.fecharModal();
          this.props.buscarPedidos()
      })
  }

  handleChange(event) {
      const file = event.target.files[0];
      if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
          return
      }
      if (file.size > tamanhoArquivoUpload) {
          showErrorMsg('Tamanho do arquivo excede 20 MB');
          return
      }
      this.converterParaBase64(file)
  }

  removerArquivo() {
      this.props.changeFieldValue('formularioReservasParaReembolsoEfetivado', 'base64ComprovanteReembolso', null);
      this.props.changeFieldValue('formularioReservasParaReembolsoEfetivado', 'nomeComprovanteReembolso', null);
      this.props.changeFieldValue('formularioReservasParaReembolsoEfetivado', 'urlComprovanteTransferencia', null);
  }

  converterParaBase64(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
          this.props.changeFieldValue('formularioReservasParaReembolsoEfetivado', 'base64ComprovanteReembolso', reader.result);
          this.props.changeFieldValue('formularioReservasParaReembolsoEfetivado', 'nomeComprovanteReembolso', file.name);
      }.bind(this);
  }

  exibirReservas () {
    return (
      <div className="vx-modal-reservas">
        <p className="vx-modal-reservas-label">Reservas selecionadas</p>
        <ul className="vx-modal-reservas-list">
          {this.props.reservas.filter(f => f.selecionada).map(reserva => (
            <li key={reserva.id} className="vx-modal-reservas-item">
              <span className="material-icons">arrow_forward</span>
              <div>
                <div className="vx-modal-reservas-route">{reserva.descCidadeOrigem} → {reserva.descCidadeDestino}</div>
                <div className="vx-modal-reservas-pax">{reserva.passageiroDto.nome}</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  exibirAnexar() {
    if (this.props.base64ComprovanteReembolso || this.props.urlComprovanteTransferencia) {
      return (
        <div className="vx-modal-attach">
          <div className="vx-modal-attach-file">
            <span className="material-icons">attach_file</span>
            <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{this.props.nomeComprovanteReembolso}</span>
            <button type="button" className="vx-modal-attach-remove" onClick={() => this.removerArquivo()}>
              <span className="material-icons">delete</span>
              Remover
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="vx-modal-attach">
        <div className="input-wrapper">
          <label className="vx-modal-attach-btn" htmlFor="input-file-reembolso">
            <span className="material-icons">file_upload</span>
            Anexar comprovante
          </label>
          <input id='input-file-reembolso' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                 onChange={this.handleChange.bind(this)} style={{display: 'none'}}/>
        </div>
        <p className="vx-modal-attach-hint">
          * Tamanho máximo permitido: 20 MB<br/>
          * Formatos suportados: PNG, JPEG, PDF<br/>
          * Para unir imagens: <a target="_BLANK" href='https://smallpdf.com/pt/jpg-para-pdf' rel='noreferrer'>smallpdf.com/pt/jpg-para-pdf</a><br/>
          * Para unir PDFs: <a target="_BLANK" href='https://smallpdf.com/pt/juntar-pdf' rel='noreferrer'>smallpdf.com/pt/juntar-pdf</a>
        </p>
      </div>
    );
  }

  render () {
    const { handleSubmit, submitting, invalid, pristine } = this.props;
    return (
      <div className="modal fade" id="modalConfirmacaoReservasParaReembolsoEfetivado" tabIndex="-1" role="dialog"
           aria-labelledby="modalConfirmacaoReservasParaReembolsoEfetivado" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" style={{borderRadius: '12px', overflow: 'hidden', border: 'none'}}>

            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">payment</span>
                Efetuar Reembolso
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Fechar">
                <span className="material-icons">close</span>
              </button>
            </div>

            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="vx-modal-body">
                {this.props.reservas && this.props.reservas.filter(f => f.selecionada) ?
                  <React.Fragment>
                    {this.exibirReservas()}
                    <p className="vx-modal-obs-label">Motivo da alteração</p>
                    <Field name='observacao' css="form-control" component={renderTextArea}
                           validate={[required]} className="form-control" label=""/>
                  </React.Fragment>
                : ''}
                {this.exibirAnexar()}
              </div>
              <div className="vx-modal-footer">
                <button id='cancelar' type="button" className="vx-modal-btn-fechar" data-dismiss="modal">
                  Não
                </button>
                <button type="submit" disabled={invalid || submitting || pristine}
                        className="vx-modal-btn-confirmar vx-modal-btn-reembolso-confirmar">
                  <span className="material-icons" style={{fontSize: '16px'}}>check_circle</span>
                  Sim, efetuar reembolso
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    )
  }
}

const selector = formValueSelector('formularioReservasParaReembolsoEfetivado');

export const mapStateToProps = state => (
  {
    reservas: state.remarcacao.reservas,
    empresaSelecionada: state.empresaSelecionada,
    urlComprovanteTransferencia: selector(state, 'urlComprovanteTransferencia'),
    nomeComprovanteReembolso: selector(state, 'nomeComprovanteReembolso'),
    base64ComprovanteReembolso: selector(state, 'base64ComprovanteReembolso'),
  });

export default connect(mapStateToProps, {
  cancelarReservasComReembolso,
  changeFieldValue
})(reduxForm({
  form: 'formularioReservasParaReembolsoEfetivado',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalConfirmacaoReservasParaReembolsoEfetivado));
